// This file is auto-generated by the codegen maintenance script
export const PACKAGE_VERSION = "15.0.6";
export const PACKAGE_NAME = "zwave-js";
